(function ($) {
  /*{
	  $('#status').text("Microphone recorder event: " + arguments[0]);

	  switch(arguments[0]) {
	}*/
  function Recorder(uploadFormId, uploadFieldName, progress_handler) {
    this.recorder = null;
    this.recorderOriginalWidth = 0;
    this.recorderOriginalHeight = 0;
    this.uploadFormId = uploadFormId;
    this.uploadFieldName = uploadFieldName;
    this.app_name = "";
    this.$el = null;
    this.ready = false;
    this.record_asked = false;
    this.recording = false;
    this.progress_handler = progress_handler;
    /*		_this.uploadFormId = uploadFormId;
				_this.uploadFieldName = uploadFieldName; //"upload_file[filename]"; */
    var _this = this;

    this.event_listener = function () {
      log("Microphone recorder event: " + arguments[0]);

      switch (arguments[0]) {
        case "ready":
          var width = parseInt(arguments[1]);
          var height = parseInt(arguments[2]);

          _this.connect(_this.app_name, 0);
          _this.recorderOriginalWidth = width;
          _this.recorderOriginalHeight = height;
          $("#play_button").css({ "margin-left": width + 8 });
          $("#save_button").css({ width: width, height: height });
          break;

        case "no_microphone_found":
          break;

        case "microphone_user_request":
          _this.showPermissionWindow();
          break;

        case "microphone_connected":
          var mic = arguments[1];

          _this.defaultSize();

          if (_this.record_asked) {
            _this.record();
          }

          var $record = $(".recorder-button.record", _this.$el),
            $stop = $(".recorder-button.stop", _this.$el);
          var new_title = $record.attr("title") + " (" + mic.name + ")";

          $record.attr("title", new_title);
          var new_title = $stop.attr("title") + " (" + mic.name + ")";

          $stop.attr("title", new_title);
          break;

        case "microphone_not_connected":
          _this.defaultSize();
          break;

        case "microphone_activity":
          $("#activity_level").text(arguments[1]);
          break;

        case "recording":
          var name = arguments[1];

          _this.record_asked = false;
          _this.recording = true;
          _this.hide();
          _this.toggle_player_button("stop", true);
          _this.toggle_player_button("play", false);
          _this.toggle_player_button("record", false);
          _this.toggle_player_button("upload", false);
          break;
        case "recording_stopped":
          var name = arguments[1];
          var duration = arguments[2];

          _this.recording = false;
          _this.show();
          _this.toggle_player_button("play", true);
          _this.toggle_player_button("stop", false);
          _this.toggle_player_button("record", true);
          _this.toggle_player_button("upload", true);
          break;

        case "playing":
          var name = arguments[1];

          _this.toggle_player_button("play", false);
          _this.toggle_player_button("stop", true);
          _this.toggle_player_button("record", false);
          _this.toggle_player_button("upload", true);
          break;

        case "playback_started":
          var name = arguments[1];
          var latency = arguments[2];

          break;

        case "stopped":
          var name = arguments[1];

          _this.toggle_player_button("play", true);
          _this.toggle_player_button("stop", false);
          _this.toggle_player_button("record", true);
          _this.toggle_player_button("upload", true);
          break;

        case "save_pressed":
          _this.progress_handler.start();
          _this.updateForm();
          break;

        case "saving":
          var name = arguments[1];

          break;

        case "saved":
          var name = arguments[1];

          // Log("post result = "+arguments[2]);
          // var data = $.parseJSON(arguments[2]);
          _this.progress_handler.success_ui();
          _this.progress_handler.success();
          break;

        case "save_failed":
          var name = arguments[1];
          var errorMessage = arguments[2];

          log("error " + errorMessage);
          $("#upload_status")
            .css({ color: "#F00" })
            .text(name + " failed: " + errorMessage);
          break;

        case "save_progress":
          var name = arguments[1];
          var bytesLoaded = parseFloat(arguments[2]);
          var bytesTotal = parseFloat(arguments[3]);

          _this.progress_handler.progress((100 * bytesLoaded) / bytesTotal);
      }
    };
  }

  Recorder.prototype.toggle_player_button = function (button, show) {
    $(".recorder-button." + button, this.$el).toggle(show);
  };

  Recorder.prototype.init = function ($el, upload_id) {
    var _this = this;

    this.$el = $el;
    this.upload_id = upload_id;
    this.flash_initialized = false;

    // Find the swf in parent
    $(".recorder-button.record", $el).click(function () {
      $(".audio-help", $el).hide();
      _this.flash_init();
      _this.record();
    });

    $(".recorder-button.stop", $el).click(function () {
      _this.stop();
    });

    $(".recorder-button.play", $el).click(function () {
      _this.playBack();
    });
    /* Won't work: file upload requires a user click on flash
		 * $(".recorder-button.upload", $el).click(function() {
			_this.save();
		});*/
  };

  Recorder.prototype.flash_init = function () {
    if (this.flash_initialized) {
      return;
    }

    this.flash_initialized = true;
    var $swf = $(".swf", this.$el),
      swf_id = "record-" + this.upload_id;

    $swf.attr("id", swf_id).css({ position: "absolute" });
    event_handler_var = "microphone_recorder_events" + this.upload_id;
    window[event_handler_var] = this.event_listener;
    this.app_name = "recorderApp-" + this.upload_id;
    var appWidth = 24,
      appHeight = 24,
      flashvars = {
        event_handler: event_handler_var,
        upload_image:
          STATIC_URL + "css/images/audio_recorder_buttons.save.24.png",
      },
      params = {},
      attributes = { id: this.app_name, name: this.app_name };

    $.getScript(STATIC_URL + "js/ubaplayer/swfobject.js", function () {
      swfobject.embedSWF(
        STATIC_URL + "js/FlashWavRecorder/recorder.swf",
        swf_id,
        appWidth,
        appHeight,
        "10.1.0",
        "",
        flashvars,
        params,
        attributes
      );
    });
  };

  Recorder.prototype.connect = function (name, attempts) {
    if (this.ready) {
      return;
    }

    if (navigator.appName.indexOf("Microsoft") != -1) {
      this.recorder = window[name];
    } else {
      this.recorder = document[name];
    }

    if (attempts >= 40) {
      return;
    }

    // Flash app needs time to load and initialize
    if (this.recorder && this.recorder.init) {
      this.recorderOriginalWidth = this.recorder.width;
      this.recorderOriginalHeight = this.recorder.height;

      if (this.uploadFormId && $) {
        var frm = $("#" + this.uploadFormId);

        this.recorder.init(
          frm.attr("action").toString(),
          this.uploadFieldName,
          frm.serializeArray()
        );
      }

      this.ready = true;
      log("connection to " + name + " OK " + this.record_asked);

      if (this.record_asked) {
        this.record();
      }

      return;
    }

    var _this = this;

    setTimeout(function () {
      _this.connect(name, attempts + 1);
    }, 100);
  };

  Recorder.prototype.playBack = function () {
    this.recorder.playBack(this.filename);
  };

  Recorder.prototype.record = function () {
    var _this = this;

    _this.record_asked = true;
    var d = new Date();
    var curr_date = d.getDate();

    if (curr_date < 10) {
      curr_date = "0" + curr_date;
    }

    var curr_month = d.getMonth();

    curr_month++;

    if (curr_month < 10) {
      curr_month = "0" + curr_month;
    }

    var curr_year = d.getFullYear();
    var curr_hour = d.getHours();

    if (curr_hour < 10) {
      curr_hour = "0" + curr_hour;
    }

    var curr_min = d.getMinutes();

    if (curr_min < 10) {
      curr_min = "0" + curr_min;
    }

    this.filename =
      "audio-" +
      curr_year +
      "-" +
      curr_month +
      "-" +
      curr_date +
      "-" +
      curr_hour +
      "_" +
      curr_min;

    if (!_this.ready) {
      return;
    }

    this.timer = setTimeout(function () {
      if (_this.recording) {
        $(".recorder-button.stop", _this.$el).click();
      }
    }, 10000);

    this.recorder.record(this.filename, this.filename + ".wav");
  };

  Recorder.prototype.stop = function () {
    if (this.recording) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.recorder.record(this.filename, "");
    } else {
      this.recorder.playBack(this.filename);
    }
  };

  Recorder.prototype.save = function () {
    this.recorder.save();
  };

  Recorder.prototype.resize = function (width, height) {
    this.recorder.width = width + "px";
    this.recorder.height = height + "px";
  };

  Recorder.prototype.defaultSize = function (width, height) {
    this.resize(this.recorderOriginalWidth, this.recorderOriginalHeight);
  };

  Recorder.prototype.show = function () {
    this.defaultSize();
    this.recorder.show();
  };

  Recorder.prototype.hide = function () {
    this.recorder.hide();
    this.resize(1, 1);
  };

  Recorder.prototype.updateForm = function () {
    var frm = $("#" + this.uploadFormId);

    this.recorder.update(frm.serializeArray());
  };

  Recorder.prototype.showPermissionWindow = function () {
    this.resize(240, 160);

    // Need to wait until app is resized before displaying permissions screen
    var me = this;

    setTimeout(function () {
      me.recorder.permit();
    }, 1);
  };

  var internal_methods = {
    create_upload_id: function () {
      return Math.floor(Math.random() * 1000000).toString(16);
    },

    create_upload_progress: function (options, $el, $form, upload_id) {
      var progress_handler = internal_methods.create_progress_handler(
        $el,
        upload_id,
        options
      );

      $form.append(
        $("<input/>", {
          type: "hidden",
          value: "parent." + progress_handler.name,
          name: "callback",
        })
      );
      var url = $form[0].action;
      var formData = new FormData($form[0]);
      progress_handler.start();
      var req = $.ajax({
        url: url,
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
      });
      req.success(function (data) {
        data = JSON.parse(data);
        progress_handler.success(data["key"]);
      });
      return req;
    },

    create_form: function (options, upload_id) {
      var form_id = "__hup_form_" + upload_id,
        input_id = "__hup_input_" + upload_id;
      var $form_file = $("<form></form>", {
        enctype: "multipart/form-data",
        encoding: "multipart/form-data",
        action: URLS["upload_file"],
        id: form_id,
        method: "post",
      });
      var $input = $("<input/>", { type: "file", id: input_id, name: "file" });
      $form_file.append($input);

      var $csrf = $("<input/>", {
        type: "hidden",
        name: "csrfmiddlewaretoken",
        value: csrftoken,
      });
      $form_file.append($csrf);

      return {
        $form: $form_file,
        $input: $input,
      };
    },

    create_file_widget: function (options, $el, upload_id) {
      var f = internal_methods.create_form(options, upload_id);
      var $form_file = f.$form,
        $input = f.$input;

      // Styling input files: put the input over the element, at opacity = 0, but with a higher z index
      var h =
        $el.height() +
        parseInt($el.css("padding-top")) +
        parseInt($el.css("padding-bottom")) +
        parseInt($el.css("border-top-width")) +
        parseInt($el.css("border-bottom-width"));
      var w =
        $el.width() +
        parseInt($el.css("padding-left")) +
        parseInt($el.css("padding-right")) +
        parseInt($el.css("border-left-width")) +
        parseInt($el.css("border-right-width"));
      var t = -parseInt($el.css("padding-top"));
      var l = -(
        parseInt($el.css("padding-left")) +
        parseInt($el.css("border-left-width"))
      );

      $form_file.addClass("hiddenuploadwrapper").css({
        width: "100%",
        height: "100%",
      });
      $el.prepend($form_file);
      $input.change(function () {
        // Post into a frame to have an asynchronous upload
        var frame_name = internal_methods.create_iframe($el, upload_id);

        $form_file.attr("target", frame_name);
        internal_methods.create_upload_progress(
          options,
          $el,
          $form_file,
          upload_id
        );
      });

      $input.before(
        $("<div>")
          .height("100%")
          .width("100%")
          .css({
            cursor: "pointer",
            position: "absolute",
            zIndex: $input.css("z-index") + 1,
          })
          .click(function () {
            $(this).hide();
            $input.click();
            $(this).show();
          })
      );
    },

    create_key: function () {
      var uuid = "";

      for (i = 0; i < 32; i++) {
        uuid += Math.floor(Math.random() * 16).toString(16);
      }

      return uuid;
    },

    create_audio_record_widget: function (options, $el, upload_id) {
      var f = internal_methods.create_form(options, upload_id);
      var key = internal_methods.create_key();
      var $form_file = f.$form,
        $input = f.$input;

      $form_file.attr(
        "action",
        $form_file.attr("action") + "?X-Progress-ID=" + key
      );
      $form_file.css({ display: "none" });
      $el.prepend($form_file);
      log("Create audio record widget");
      var progress_handler = internal_methods.create_progress_handler(
        $el,
        upload_id,
        options
      );

      progress_handler.key = key;
      var recorder = new Recorder(
        $form_file.attr("id"),
        $input.attr("name"),
        progress_handler
      );

      recorder.init($el, upload_id);
    },

    create_iframe: function ($el, upload_id) {
      var frame_name = "__hup_iframe_" + upload_id;

      $("iframe [name=" + frame_name + "]").remove();
      var $iframe = $("<iframe>", {
        id: frame_name,
        name: frame_name,
        width: "0",
        height: "0",
        border: "0",
        style: "width: 0; height: 0; border: none; position: absolute; ",
      });

      // Add to document...
      $el.append($iframe);
      window.frames[frame_name].name = frame_name;

      $iframe.find("onload", function () {
        $iframe.unbind("onload");

        // Del the iframe...
        // setTimeout($iframe.remove, 250);
      });

      return frame_name;
    },

    create_progress_handler: function ($el, upload_id, options) {
      var handler_name = "__uploadhandler_" + upload_id;
      var progressHandler = {
        start: function (filename) {
          if (!$(".progress", $el).length) {
            progressHandler.progress_div = $("<div/>", {
              text: "-",
              class: "round-progress-48",
              css: {
                opacity: 0.6,
                position: "absolute",
                left: $el.width() + 5,
                top: "-16px",
              },
            }).addClass("progress");
            $el.prepend(progressHandler.progress_div);
          } else {
            $(".progress", $el)
              .show()
              .css("background-position", "0px 0px")
              .text("-");
          }
        },

        cancel: function () {
          $(".progress", $el).hide();
        },

        success_ui: function () {
          log("success ui");
          $(".progress", $el).hide();
          log("success ui ok");
        },

        key: null,
        success: function (key) {
          log("success with key" + this.key);

          if (!key && this.key) {
            options.success("File" + this.key);
          } else if (key) {
            // This is called from the iframe, when upload POST is finished and iframe reloads.
            options.success(key);
          }
        },

        progress: function (percent) {
          var int_percent = parseInt(percent);
          var progress_percent =
            int_percent < 10 ? "0" + int_percent : int_percent;
          var x_position = -Math.round((12 * percent) / 100) * 48;

          $(".progress", $el)
            .show()
            .css("background-position", x_position + "px 0px")
            .text(progress_percent + "%");
        },

        name: handler_name,
      };

      window[handler_name] = progressHandler;

      return progressHandler;
    },
  };

  var methods = {
    set: function (is_favorite) {},

    init: function (options) {
      return this.each(function () {
        var $this = $(this),
          data = $this.data("upload");
        var defaults = {
          type: "file",
        };

        options = $.extend(defaults, options);

        if (!data) {
          data = options;
          var upload_id = internal_methods.create_upload_id();

          switch (options["type"]) {
            case "file":
            case "font":
              internal_methods.create_file_widget(options, $this, upload_id);
              break;
            case "audio":
              internal_methods.create_audio_record_widget(
                options,
                $this,
                upload_id
              );
              break;
          }
          $this.addClass("relative");
        }

        $this.data("upload", data);
      });
    },
  };

  $.fn.hidden_upload_button = function (method) {
    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "Method " + method + " does not exist on jQuery.hidden_upload_button"
      );
    }
  };
})(jQuery); /* Hidden_upload_button */

$.fn.upload_button = function (o) {
  return this.each(function () {
    var $me = $(this);

    $me.css({ position: "relative" });
    var progressHandler = {
      start: function (filename) {
        if (!$(".progress", $me).length) {
          progressHandler.progress_div = $("<div/>", {
            text: "-",
            class: "round-progress-48",
            css: {
              opacity: 0.6,
              position: "absolute",
              left: $me.width() + 5,
              top: "-16px",
            },
          }).addClass("progress");
          $me.prepend(progressHandler.progress_div);
        } else {
          $(".progress", $me)
            .show()
            .css("background-position", "0px 0px")
            .text("-");
        }
      },

      cancel: function () {
        $(".progress", $me).hide();
      },

      success: function () {
        $(".progress", $me).hide();
      },

      progress: function (filename, percent, timeLeftStr) {
        var int_percent = parseInt(percent);
        var progress_percent =
          int_percent < 10 ? "0" + int_percent : int_percent;
        var x_position = -Math.round((12 * percent) / 100) * 48;

        $(".progress", $me)
          .show()
          .css("background-position", x_position + "px 0px")
          .text(progress_percent + "%");
      },
    };
    var handler_name =
      "__uploadhandler_" + Math.floor(Math.random() * 1000000).toString(16);

    window[handler_name] = progressHandler;
    $("iframe, form", $me).remove();
    $me.prepend(
      '<iframe title="Sculteo Upload Media" class="upload-button-iframe absolute" src="" scrolling="no" frameborder="0" style="margin-top: 0px;  width:100%; height:100%; z-index: 2000;" ALLOWTRANSPARENCY="true"></iframe>'
    );
    var iframe = $("iframe", $(this));
    var ie = 0; // @cc_on + @_jscript_version

    iframe.css({ width: $me.width(), height: $me.height() });
    iframe
      .attr(
        "src",
        URLS["upload_frame"] + "?style=button&callback=parent." + handler_name
      )
      .bind("load", function () {
        var win = this.contentWindow;

        switch (win.step) {
          case "init":
            var form = $("form", $(win.document));
            var el = $("#id_file", form);

            el.css({ "font-size": "0px" });
            form.css({ width: iframe.width(), height: iframe.height() });
            $(win.document).bind("mousemove", function (evt) {
              var x = evt.clientX;
              var y = evt.clientY;
              var w = el.width();
              var h = el.height();
              var top = y - h;
              var left = x;

              if ($.browser.msie) {
                if (ie >= 9) {
                  left -= w - 2;
                  top = y - h / 2;
                } else {
                  left = x - w - 4;
                  top = y - h / 2 - 4;
                }
              } else if ($.browser.mozilla) {
                left -= 16;
                top = y - h / 2;
              }

              el.css({ top: top + "px", left: left + "px" });
            });

            if (o.ready) {
              o.ready();
            }

            break;
          case "done":
            if (win.error && o.error) {
              o.error(win.error);
            }

            if (!win.error && o.success) {
              o.success(win.cache_key);
            }

            $(this).attr(
              "src",
              URLS["upload_frame"] +
                "?style=button&callback=parent." +
                handler_name
            );
            break;
        }
      });
  });
};
